<script lang="ts" setup>
import FooterIcons from "~/components/Footer/Icons.vue";
import FooterNav from "~/components/Footer/Nav.vue";
import NavbarMenu  from "~/components/Navbar/Menu.vue";

const page = {
    pageBuilder: {
        isNavFixed: true
    }
}

</script>
<template>
    <NavbarMenu :page="page"/>
    <slot />
    <FooterIcons/>
    <FooterNav/>
</template>
